module.exports = __webpack_public_path__ + "img/molten.841f78d2.png";